/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon32Regular = forwardRef('CheckAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M28.436 7.543a1 1 0 0 1 0 1.414L14.77 22.622a4.175 4.175 0 0 1-5.905 0L3.793 17.55a1 1 0 0 1 1.414-1.415l5.074 5.074c.85.85 2.226.85 3.076 0L27.022 7.543a1 1 0 0 1 1.414 0Z" })));
});
